


























































































import { Component, Vue, Watch } from "vue-property-decorator";
import { storeSupervisiAmbulans } from "@/store/modules/SupervisiAmbulansStore";
import SupervisiAmbulansSvc from "@/services/SupervisiAmbulansService";

@Component({})
export default class SupervisiAmbulansListPage extends Vue {
  filter = {
    tanggal_dari: "",
    tanggal_sampai: "",
    signed: null as boolean | null,
  };

  signedOpts = [
    { text: "Sudah TTD lengkap", value: true },
    { text: "Belum final", value: false },
  ];

  pagination = {
    page: 1,
    itemsPerPage: 15,
  };

  headers = [
    { text: "Nomor Formulir", value: "nomor_formulir" },
    { text: "Tanggal", value: "tanggal_supervisi" },
    { text: "Ambulans", value: "ambulans", sortable: false },
    { text: "Supervisor", value: "supervisor", sortable: false },
    { text: "Status", value: "status", sortable: false },
    { text: "Aksi", value: "actions", sortable: false, align: "end" },
  ];

  get items() {
    return storeSupervisiAmbulans.items;
  }

  get loading() {
    return storeSupervisiAmbulans.loading;
  }

  get meta() {
    return storeSupervisiAmbulans.meta;
  }

  mounted() {
    this.fetch();
  }

  @Watch("pagination", { deep: true })
  onPagination() {
    this.fetch();
  }

  fetch() {
    const params: any = {
      page: this.pagination.page,
      per_page: this.pagination.itemsPerPage,
    };
    if (this.filter.tanggal_dari) params.tanggal_dari = this.filter.tanggal_dari;
    if (this.filter.tanggal_sampai) params.tanggal_sampai = this.filter.tanggal_sampai;
    if (this.filter.signed !== null && this.filter.signed !== undefined) {
      params.signed = this.filter.signed;
    }
    storeSupervisiAmbulans.fetchList(params);
  }

  applyFilter() {
    this.pagination.page = 1;
    this.fetch();
  }

  resetFilter() {
    this.filter = { tanggal_dari: "", tanggal_sampai: "", signed: null };
    this.applyFilter();
  }

  createNew() {
    this.$router.push({ name: "supervisi-ambulans-form", params: { id: "baru" } });
  }

  openEdit(id: number) {
    this.$router.push({ name: "supervisi-ambulans-form", params: { id: String(id) } });
  }

  printPdf(id: number) {
    SupervisiAmbulansSvc.printPdf(id);
  }

  formatDate(d: string) {
    if (!d) return "-";
    const [y, m, day] = d.split("-");
    return `${day}-${m}-${y}`;
  }
}
